export default __webpack_public_path__ + "static/media/logoOnb.0b435761.png";